<template lang='html'>
    <footer class="footer">
        <v-layout justify-space-between align-center class="footer__wrap"
                  v-bind="binding"
        >
            <v-flex lg3>
                <Logo :url="require('../../../../public/images/' + logo)" classes_added="footer__logo" />
                <v-flex mt-4>
                    <v-layout row wrap justify-space-between>
                        <a href="https://www.youtube.com/channel/UCcBwY4Qdi4PEMezhmoQ5PtA" target='_blank'>
                            <svg v-svg
                                 symbol="youtube"
                                 size="24"
                                 class="icon"
                                 role="presentation"
                            />
                        </a>
                        <a href="https://vk.com/lukoilmasla" target='_blank'>
                            <svg v-svg
                                 symbol="vk"
                                 size="24"
                                 class="icon"
                                 role="presentation"
                            />
                        </a>
                        <a target='_blank'>
                            <!--
                          <svg v-svg
                                 symbol="facebook"
                                 size="24"
                                 class="icon"
                                 role="presentation"
                            />-->
                        </a>
                        <a target='_blank'>
                            <!--
                            <svg v-svg
                                 symbol="instagram"
                                 size="24"
                                 class="icon"
                                 role="presentation"
                            />-->
                        </a>
                    </v-layout>
                </v-flex>
                <!-- <v-layout row wrap class="mt-4"
                          :class="{'justify-center': $vuetify.breakpoint.xs}"
                >

                </v-layout> -->
            </v-flex>
            <v-flex md8 xs12 class="footer-links"
                    :class="{
                        'pl-5': $vuetify.breakpoint.mdAndUp,
                        'align-self-stretch': $vuetify.breakpoint.smAndDown
                    }"
            >
                <v-layout row wrap :class="{'justify-center': $vuetify.breakpoint.smAndDown && chunked_footer_links.length === 1}">
                    <!-- <div v-for="(item, i) in menu" :key="i" class="footer__nav-item mb-4">
                        <router-link v-if="item.link" class="footer__nav-link" :to="item.link">{{ $t(item.text) }}</router-link>
                    </div> -->

                    <template v-if="chunked_footer_links.length > 0">
                        <v-flex
                            v-for="(chunk, i) in chunked_footer_links" :key="i" xs6
                            md4 lg3 wrap
                            :class="{'pb-2': $vuetify.breakpoint.smAndDown, 'pr-2': $vuetify.breakpoint.xsOnly}"
                        >
                            <v-flex v-for="(link, j) in chunk" :key="j"
                                    class="text-md-left text-xs-center mt-2"
                            >
                                <linkWhite class="grey-text" :href="link.link" target="_blank">
                                    {{ link.name }}
                                </linkWhite>
                            </v-flex>
                        </v-flex>
                    </template>
                </v-layout>
            </v-flex>
            <v-flex column class="text-md-right text-xs-center">
                <!-- <router-link :to="{name: 'contact'}">
                    <buttonTransparent class="ml-2 mt-2">{{$t("Обратная связь")}}</buttonTransparent>
                </router-link> -->
                <v-dialog :value="request_modal" max-width="620" persistent
                          no-click-animation
                >
                    <contactModal />
                </v-dialog>
                <!-- <buttonTransparent class="ml-2 mt-2" @click.native="OPEN_CONTACT_MODAL()">{{$t("Техподдержка")}}</buttonTransparent> -->
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex class="xs12 grey-text text-md-left text-xs-center mt-2">
                {{ $t("Copyright {year} ПАО ЛУКОЙЛ", { year: (new Date()).getFullYear() }) }}
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex class="xs12 grey-text text-md-left text-xs-center mt-2">
                {{ $t("115035, Российская Федерация, г. Москва, вн. тер. г. муниципальный округ Замоскворечье, улица Садовническая, д. 75") }}
            </v-flex>
        </v-layout>
    </footer>
</template>

<script>
import Logo from '@/components/ui/logo/logo.vue';
import linkWhite from '@/components/ui/links/styled/link_white.vue';
// import buttonTransparent from '@/components/ui/buttons/button_transparent';
import contactModal from '@/components/view_blocks/Contact/Contact_modal.vue';
import {mapGetters, mapMutations} from 'vuex';
import chunk from 'lodash.chunk';
import REGION_CODES from '@/configs/region_codes';

export default {
  name      : 'Footer',
  components: {
    Logo,
    linkWhite,
    contactModal,
    // buttonTransparent,
  },
  props: {
    url: {
      type: String,
    },
    classes_added: {
      type: String,
    },
  },
  data() {
    return {
      menu: [],
    };
  },
  computed: {
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true;
      return binding;
    },
    ...mapGetters('contact/requests', [
      'request_modal',
    ]),
    ...mapGetters('profile/general', ['lang']),
    ...mapGetters('common', ['footer_links']),
    ...mapGetters('profile/user', [
      'user',
    ]),
    logo() {
      return this.user.region_code === REGION_CODES.BITUM_MATERIALS ? 'lukoil-logo-w.svg' : this.lang == 'ru' ? 'lukoil-logo-white.png' : 'lukoil-logo-white-en.svg';
    },
    chunked_footer_links() {
      return (this.footer_links && this.footer_links.length > 0) ? chunk(this.footer_links, 3) : [];
    },
  },
  mounted() {
    this.menu = [
      {text: this.user.region_code === REGION_CODES.BITUM_MATERIALS ? 'Методические материалы' : 'Международные классификации', link: {name: 'database', hash: '#classification'}},
      {text: 'Продуктовый портфель', link: {name: 'database', hash: '#products'}},
      {text: 'Спецификации OEM', link: {name: 'database', hash: '#oem'}},
      {text: 'Глоссарий', link: {name: 'database', hash: '#glossary'}},
      {text: 'Новости и мероприятия', link: {name: 'news_main'}},
      // {text: 'Банк идей', link: {name: 'ideas_bank'}},
      {text: 'Вопрос-ответ', link: {name: 'faq'}},
    ];
  },
  methods: {
    ...mapMutations('contact/requests', [
      'OPEN_CONTACT_MODAL',
    ]),
  },
};
</script>
